var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "white-X-icon",
    transform: "translate(-275.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316,0 L316,499 L0,499 L0,0 L316,0 Z",
    id: "Rectangle-8-Copy-11",
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(276.000000, 20.000000)",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 20,
    y2: 0,
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 0,
    y2: 0,
    id: "Line-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(20.000000, 20.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteXIcon);
export default __webpack_public_path__ + "static/media/white-x-icon.fe0f863b86259a37b11240a300d99980.svg";
export { ForwardRef as ReactComponent };